import UIkit from 'uikit'

const timeout = 3000
const typeNotif = {
  1: {
    text: 'success',
    icon: 'ic_check_circle_green.svg'
  },
  2: {
    text: 'danger',
    icon: 'warning'
  },
  3: {
    text: 'primary',
    icon: 'info'
  },
  4: {
    text: 'primary',
    icon: 'info'
  }
}
const createMessage = (err) => {

  let data = null
  if (err.response) {
    const message = err.response
    data = typeof message.data === 'object' ? message.data.error || message.data.message : message.data
  } else {
    data = err.message || err
  }

  return data || 'Something went wrong'
}

const notificationSuccess = (message, images) => {
  UIkit.notification({
    message: `<img class="uk-margin-small-right" src="${images || '/images'}/icon/${typeNotif[1].icon}" /> ${message || 'Success'}`,
    status: typeNotif[1].text,
    timeout
  })
}

const notificationDanger = (message) => {
  UIkit.notification({
    message: `<span class="uk-margin-small-right" uk-icon='icon: ${typeNotif[2].icon}'></span> ${createMessage(message)}`,
    status: typeNotif[2].text,
    timeout
  })
}

const notificationInfo = (message) => {
  UIkit.notification({
    message: `<span class="uk-margin-small-right" uk-icon='icon: ${typeNotif[3].icon}'></span> ${message}`,
    status: typeNotif[3].text,
    timeout
  })
}

const notificationAlert = (message) => {
  UIkit.notification({
    message: `<span class="uk-margin-small-right" uk-icon='icon: ${typeNotif[2].icon}'></span> ${message}`,
    status: typeNotif[2].text,
    timeout
  })
}

const notificationNewMessage = (title, body) => {
  UIkit.notification({
    message: `
    <div class="uk-flex">
    <div>
    <span class="uk-margin-small-right" uk-icon='icon: ${typeNotif[2].icon}'></span>
    </div>
    <div clas="uk-flex">
    <p>${title}</p>
    ${body}
    </div>
    </div>`,
    status: typeNotif[4].text,
    pos: 'top-right',
    timeout
  })
}


export {
  notificationSuccess,
  notificationDanger,
  notificationInfo,
  notificationAlert,
  notificationNewMessage
}
